<template>
    <transition name="accordion" v-on="hooks">
        <slot></slot>
    </transition>
</template>

<script>
    export default {
        props: {
            duration: {
                type: Number,
                default: 300
            }
        },
        computed: {
            hooks() {
                return {
                    beforeEnter: this.close,
                    enter: this.open,
                    beforeLeave: this.open,
                    leave: this.close,
                    ...this.$listeners
                };
            }
        },
        methods: {
            close(el) {
                el.style.transitionDuration = `${this.duration}ms`;
                el.style.height = '0px';

            },
            open(el) {
                el.style.transitionDuration = `${this.duration}ms`;
                el.style.height = 'auto';
            }
        },
    }
</script>

<style>
    .accordion-body {
        overflow: hidden;
        transition-property: height;
        transition-timing-function: cubic-bezier(.46, .29, .69, .46);
    }
</style>